const actionLabels = {
    view: 'Просмотр',
    create: 'Создание',
    edit: 'Изменение',
    delete: 'Удаление',
    generate: 'Генерация',
    scan: 'Сканирование',
    write: 'Изменение данных',
    assign: 'Назначение',
    complete: 'Завершение',
    cancel: 'Отмена',
	order: 'Заказ',
	product: 'Продукт',
	phase: 'Фаза',
	
    shifts: {
        '1': '1 смена',
        '2': '2 смена',
        '3': '3 смена',
        'day': 'Дневная',
        'night': 'Ночная'
    },
    status: {
        'pending': 'В ожидании',
        'in_progress': 'В работе',
        'completed': 'Завершен',
        'cancelled': 'Отменен',
        'overdue': 'Просрочен',
		'assigned': 'Назначен',
		'done': 'Выполнен',
		'planned': 'Планируется'
    },
	priority: {
		'low': 'Низкий',
		'normal': 'Средний',
		'high': 'Высокий',
		'urgent': 'Срочный'
	}
};

export default actionLabels;
